import { FormikProps } from "formik";
import { TextInputFormik } from "../../../../formcontrols/InputItem";
import { OpretFirmaStep1Formik } from "../../opretFirmaInterface";
import { AddressGenericFormSet } from "../../../../formcontrols/sets/AddressGenericFormSet";
import { isEuCountryOutsideDenmark } from "../../../../../util/vatValidation";

const OpretFirmaUDL = ({
  formik,
}: {
  formik: FormikProps<OpretFirmaStep1Formik>;
}) => {
  // Påkrævet for EU-lande: BC kan kun momsklassificere debitoren (omvendt betalingspligt) med et VAT-nr.
  const vatRequired = isEuCountryOutsideDenmark(
    formik.values.andenAdresse?.landekode,
  );
  return (
    <>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "navn",
            initialValue: "",
            label: "Firmanavn",
            isRequired: true,
            placeholder: "Indtast firmanavn",
          }}
          formik={formik}
        />
      </div>
      <AddressGenericFormSet formik={formik} />
      <div className="w-100">
        <TextInputFormik
          config={{
            component: "textinput",
            id: "udenlandskCvr",
            initialValue: "",
            label: "VAT-nr.",
            isRequired: vatRequired,
            placeholder: "fx DE123456789",
          }}
          formik={formik}
        />
      </div>
    </>
  );
};

export default OpretFirmaUDL;
